import React from "react";
import { createRoot } from "react-dom/client";
import MonDVMap2 from "./pages/monitoreoDatosVarsMapa";

// css
import "bootstrap/dist/css/bootstrap.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./index.css";
import "./scss/react.scss";

//ReactDOM.render(<MonitoreoDatosVarsMapa />, document.getElementById("root"));

const App = () => {
    const renderPage = () => {
        return <MonDVMap2 />;
    };
    return renderPage();
};
const root = createRoot(document.getElementById("root"));
root.render(<App />);
